import React, { Component, Fragment } from 'react';
import { suggestions, trackAutoSelection } from '../../utils/interface';
import SearchBar from '../../components/search-bar';

class SearchBarContainer extends Component {
  docType = this.props.app === 'ELSS' ? 'documents' : 'documents';

  constructor(props) {
    super(props);
  }

  state = {
    value: '',
    siteSelected: '',
    suggestions: [],
  };

  componentDidMount() {
    this.getSuggestion();
  }

  clearSuggestions = () =>
    this.setState({
      ...this.state,
      suggestions: [],
    });

  getSuggestion = (qs, s) => {
    qs &&
      suggestions(qs, s || '').then((suggestions) => {
        if (Array.isArray(suggestions) && suggestions.length > 0) {
          this.setState({ ...this.state, suggestions });
        }
      });
  };

  tAutocompleteSelection = (docId, query, requestId) => {
    trackAutoSelection(docId, query, requestId);
  };

  render() {
    return (
      <Fragment>
        {this.props.app && (
          <SearchBar
            app={this.props.app || 'cap-web'}
            tAutocompleteSelection={this.tAutocompleteSelection}
            redirectType={this.props.redirectType || 'relative'}
            searchRedirect={this.props.searchRedirect || ''}
            suggestions={this.state.suggestions}
            getSuggestion={this.getSuggestion}
            clearSuggestions={this.clearSuggestions}
          />
        )}
      </Fragment>
    );
  }
}

export default SearchBarContainer;
